export const PageHeader = ({ eyebrow, title, text, actions, testid = "page-header" }) => (
  <header className="fade-up flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-testid={testid}>
    <div>
      {eyebrow && <div className="eyebrow">{eyebrow}</div>}
      <h1 className="mt-1 text-3xl font-extrabold sm:text-4xl lg:text-5xl">{title}</h1>
      {text && <p className="mt-2 max-w-2xl text-sm font-medium text-muted-foreground sm:text-base">{text}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </header>
);
